import React from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import { isRichText } from './richText';
import styles from './RichText.module.css';

/**
 * Exibe um texto gravado pelo `RichTextField`. HTML passa pelo sanitizador
 * antes de renderizar; texto puro antigo é mostrado como sempre foi, com as
 * quebras de linha.
 */
const RichTextView = ({ value, className = '' }) => {
  if (isRichText(value)) {
    return (
      <div
        className={`${styles.view} ${className}`}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }}
      />
    );
  }
  return <div className={`${styles.view} ${styles.plain} ${className}`}>{value}</div>;
};

export default RichTextView;
